export default function (num) {
  var parts = num.slice(0, 20)
  return parts
}
